import CampoData from '@/components/Formulario/CampoData';
import CampoTexto from '../../components/Formulario/CampoTexto';
import Grid, { GridItem } from '../../components/layout/Grid';
import CampoMultiSeletor from '@/components/Formulario/CampoMultiSeletor';
import { useQuery } from 'react-query';
import axios from 'axios';
import CampoNumero from '@/components/Formulario/CampoNumero';
import CampoDinheiro from '@/components/Formulario/CampoDinheiro';
import HBox from '@/components/layout/HBox';
import CampoMemo from '@/components/Formulario/CampoMemo';
import CampoSeletor from '@/components/Formulario/CampoSeletor';
import { mdiCalendarCheck, mdiCalendarClock, mdiCalendarHeart, mdiCalendarRemove } from '@mdi/js';
import Icon from '@mdi/react';
import CampoCheckbox from '@/components/Formulario/CampoCheckbox';
import { format } from 'date-fns';

export const FormAtividade = ({
  value,
  onChange,
  fieldErrors,
}: {
  value: any;
  onChange: any;
  fieldErrors: any;
}) => {
  const qClientes = useQuery(
    'cliente/box',
    async () => {
      const res = await axios.get('/api/cliente/box');
      return res.data;
    },
  );
  const clientesOptions =
    qClientes.data?.result?.map((it: any) => ({
      id: it.id,
      label: it.nome,
    })) ?? [];

  const qAgendas = useQuery({
    queryKey: ['agenda/box', value?.id_cliente],
    queryFn: async () => {
      const res = await axios.get(`/api/agenda/box`);
      return res.data;
    },
  });
  const agendas = qAgendas.data?.result ?? [];
  const agendasOptions = agendas.map((it: any) => ({
    id: it.id,
    label: it.titulo,
  }));

  const qCategorias = useQuery('categoria_financeira/box:receita', async () => {
    const res = await axios.get('/api/categoria_financeira/box', {
      params: { tipo: 'receita' },
    });
    return res.data;
  });
  const categoriasOptions =
    qCategorias.data?.result?.map((it: any) => ({
      id: it.id,
      label: it.nome,
    })) ?? [];

  const qCentrosCusto = useQuery('centro_custo/box', async () => {
    const res = await axios.get('/api/centro_custo/box');
    return res.data;
  });
  const centrosCustoOptions =
    qCentrosCusto.data?.result?.map((it: any) => ({
      id: it.id,
      label: it.nome,
    })) ?? [];

  const qVendas = useQuery({
    queryKey: ['venda/box', value?.id_cliente],
    queryFn: async () => {
      const res = await axios.get(
        `/api/venda/box${value?.id_cliente ? `?id_cliente=${value.id_cliente}` : ''}`,
      );
      return res.data;
    },
    enabled: value?.natureza === 'servico',
  });
  const vendasOptions =
    qVendas.data?.result?.map((it: any) => ({
      id: it.id,
      label: `#${it.id}${it['produto.nome'] ? ` · ${it['produto.nome']}` : ''}${it.valor_total != null
        ? ` · ${Number(it.valor_total).toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        })}`
        : ''
        }`,
    })) ?? [];

  // Ao escolher a agenda, herda a natureza padrão dela (decisão C) se ainda não definida
  const onChangeAgenda = (id_agenda: any) => {
    const ag = agendas.find((a: any) => a.id === id_agenda);
    const next: any = { ...value, id_agenda };
    if (value?.natureza == null && ag) {
      next.natureza = ag.faturavel_default ? 'servico' : 'reuniao';
    }
    onChange(next);
  };

  // Mover o início arrasta o término junto, preservando a duração — sem isso é
  // fácil deixar o evento terminando antes de começar.
  const onChangeDataEvento = (v: string) => {
    const next: any = { ...value, data_evento: v };

    const inicio = v ? new Date(v) : null;
    if (inicio && !isNaN(inicio.getTime())) {
      const inicioAnterior = value?.data_evento ? new Date(value.data_evento) : null;
      const fim = value?.data_fim_evento ? new Date(value.data_fim_evento) : null;

      const duracao =
        inicioAnterior && fim && !isNaN(inicioAnterior.getTime()) && !isNaN(fim.getTime())
          ? fim.getTime() - inicioAnterior.getTime()
          : null;

      next.data_fim_evento = format(
        new Date(inicio.getTime() + (duracao && duracao > 0 ? duracao : 60 * 60 * 1000)),
        "yyyy-MM-dd'T'HH:mm:ss",
      );
    }

    onChange(next);
  };

  const periodoInvalido =
    !!value?.data_evento &&
    !!value?.data_fim_evento &&
    new Date(value.data_fim_evento) < new Date(value.data_evento);

  const isServico = value?.natureza === 'servico';
  const ehServicoAvulso = isServico && !value?.id_venda;

  // Sub-objeto enviado à rota para criar/atualizar o lançamento (receita)
  // ligado a este serviço avulso. Os valores já existentes (ao editar) vêm de
  // `lancamento_financeiro`, que é o que a rota GET /:id retorna.
  const lancamento = {
    descricao: value?.titulo,
    valor: value?.lancamento_financeiro?.valor,
    data_vencimento: value?.data_evento
      ? format(new Date(value.data_evento), 'yyyy-MM-dd')
      : undefined,
    id_categoria: value?.lancamento_financeiro?.id_categoria,
    id_centro_custo: value?.lancamento_financeiro?.id_centro_custo,
    obs: value?.lancamento_financeiro?.obs,
    ...value?.lancamento,
  };
  const onChangeLancamento = (campo: string, v: any) => {
    onChange({ ...value, lancamento: { ...lancamento, [campo]: v } });
  };

  return (
    <Grid>
      <div style={{ position: 'absolute', height: 0 }}>
        <input
          type="text"
          name="username"
          style={{
            height: 0,
            width: 0,
            border: 'none',
            outline: 'none',
            margin: 0,
            padding: 0,
          }}
        />
        <input
          type="password"
          name="password"
          style={{
            height: 0,
            width: 0,
            border: 'none',
            outline: 'none',
            margin: 0,
            padding: 0,
          }}
        />
      </div>
      <GridItem sm={12} md={6} lg={4}>
        <CampoTexto
          instanceId="titulo"
          value={value?.titulo ?? ''}
          onChange={v => onChange({ ...value, titulo: v })}
          label="Título"
          error={fieldErrors?.titulo}
        />
      </GridItem>

      <GridItem sm={12} md={3} lg={4}>
        <CampoData
          instanceId="data_evento"
          type='datetime-local'
          value={value?.data_evento ?? ''}
          onChange={onChangeDataEvento}
          label="Data"
          error={fieldErrors?.data_evento}
        />
      </GridItem>

      <GridItem sm={12} md={3} lg={4}>
        <CampoData
          instanceId="data_fim_evento"
          type='datetime-local'
          value={value?.data_fim_evento ?? ''}
          onChange={v => onChange({ ...value, data_fim_evento: v })}
          label="Término"
          min={value?.data_evento || undefined}
          error={
            fieldErrors?.data_fim_evento ??
            (periodoInvalido ? 'O término deve ser depois do início' : undefined)
          }
        />
      </GridItem>


      <GridItem sm={12} md={8}>
        <CampoSeletor
          nullable
          instanceId='id_cliente'
          value={value?.id_cliente ?? []}
          onChange={v => onChange({ ...value, id_cliente: v })}
          label="Cliente"
          error={fieldErrors?.id_cliente}
          options={clientesOptions}
        />
      </GridItem>

      <GridItem sm={12} md={4}>
        <CampoSeletor
          nullable
          instanceId='id_agenda'
          value={value?.id_agenda ?? []}
          onChange={onChangeAgenda}
          label="Agenda associada"
          error={fieldErrors?.id_agenda}
          placeholder='(Não associada)'
          options={agendasOptions}
        />
      </GridItem>

      <GridItem sm={12} md={4}>
        <CampoSeletor
          instanceId="natureza"
          label="Natureza"
          value={value?.natureza ?? 'reuniao'}
          onChange={v => onChange({ ...value, natureza: v })}
          error={fieldErrors?.natureza}
          options={[
            { id: 'reuniao', label: 'Reunião' },
            { id: 'servico', label: 'Serviço prestado' },
          ]}
        />
      </GridItem>

      <GridItem sm={12} md={4}>
        <CampoSeletor
          instanceId='estado'
          label="Estado da atividade"
          value={value?.estado ?? ''}
          onChange={v => onChange({ ...value, estado: v })}
          error={fieldErrors?.estado}
          options={[
            { id: 'pendente', label: <HBox><Icon path={mdiCalendarClock} size={0.75} color="var(--tc-color-gray-400)" />Pendente</HBox> },
            { id: 'confirmada', label: <HBox><Icon path={mdiCalendarHeart} size={0.75} color="var(--tc-color-success-500)" />Confirmada</HBox> },
            { id: 'concluida', label: <HBox><Icon path={mdiCalendarCheck} size={0.75} color="var(--tc-color-success-500)" />Concluída</HBox> },
            { id: 'cancelada', label: <HBox><Icon path={mdiCalendarRemove} size={0.75} color="var(--tc-color-danger-500)" />Cancelada</HBox> },
          ]}
        />
      </GridItem>

      <GridItem sm={12} md={4}>
        <CampoNumero
          instanceId="avisar_minutos"
          label='Avisar'
          value={value?.avisar_minutos ?? 0}
          onChange={v => onChange({ ...value, avisar_minutos: v })}
          error={fieldErrors?.avisar_minutos}
          append={<span style={{ whiteSpace: 'nowrap' }}>minutos antes</span>}
        />
      </GridItem>

      <GridItem sm={12} md={6}>
        {value?.usuario?.nome && (<CampoTexto
          readOnly
          disabled
          label='Usuário responsável'
          defaultValue={value?.usuario?.nome ?? ''}
        />)}
        {value?.grupo?.nome && (<CampoTexto
          readOnly
          disabled
          label='Grupo responsável'
          defaultValue={value?.grupo?.nome ?? ''}
        />)}
      </GridItem>

      {isServico && (
        <>
          <GridItem sm={12}>
            <strong style={{ color: 'var(--tc-color-gray-500)' }}>
              Serviço prestado
            </strong>
          </GridItem>
          <GridItem sm={12} md={6}>
            <CampoSeletor
              nullable
              instanceId='id_venda'
              label='Vínculo à venda'
              value={value?.id_venda ?? []}
              onChange={v => onChange({ ...value, id_venda: v })}
              error={fieldErrors?.id_venda}
              placeholder='(Avulso, sem venda)'
              options={vendasOptions}
            />
          </GridItem>

          {ehServicoAvulso && (
            <>
              <GridItem sm={12} md={6}>
                <CampoSeletor
                  nullable
                  instanceId='lancamento.id_categoria'
                  label='Categoria'
                  value={lancamento.id_categoria ?? []}
                  onChange={v => onChangeLancamento('id_categoria', v)}
                  placeholder='(Sem categoria)'
                  options={categoriasOptions}
                />
              </GridItem>
              <GridItem sm={12} md={3}>
                <CampoDinheiro
                  instanceId='lancamento.valor'
                  label='Valor'
                  value={lancamento.valor ?? 0}
                  onChange={v => onChangeLancamento('valor', v)}
                  error={fieldErrors?.['lancamento.valor']}
                />
              </GridItem>
              <GridItem sm={12} md={3}>
                <CampoData
                  instanceId='lancamento.data_vencimento'
                  type='date'
                  label='Vencimento da receita'
                  value={lancamento.data_vencimento ?? ''}
                  onChange={v => onChangeLancamento('data_vencimento', v)}
                  error={fieldErrors?.['lancamento.data_vencimento']}
                />
              </GridItem>
              <GridItem sm={12} md={6}>
                <CampoSeletor
                  nullable
                  instanceId='lancamento.id_centro_custo'
                  label='Centro de custo'
                  value={lancamento.id_centro_custo ?? []}
                  onChange={v => onChangeLancamento('id_centro_custo', v)}
                  placeholder='(Sem centro de custo)'
                  options={centrosCustoOptions}
                />
              </GridItem>
            </>
          )}

          {value?.id_venda && (
            <GridItem sm={12}>
              <small style={{ color: 'var(--tc-color-gray-400)' }}>
                Vinculado a uma venda: a receita é a gerada pela venda ao ser
                ganha (evita dupla contagem). Esta atividade só registra a
                execução do serviço.
              </small>
            </GridItem>
          )}
        </>
      )}

      <GridItem sm={12}>
        <CampoTexto
          instanceId='local'
          label='Local'
          value={value?.local ?? ''}
          onChange={v => onChange({ ...value, local: v })}
          error={fieldErrors?.local}
        />
      </GridItem>
      <GridItem sm={12}>
        <CampoMemo
          instanceId='obs'
          label='Observações'
          value={value?.obs ?? ''}
          onChange={v => onChange({ ...value, obs: v })}
          error={fieldErrors?.obs}
        />
      </GridItem>
    </Grid>
  );
};
